module.exports = __webpack_public_path__ + "static/media/W19-1193_Free_Root_Beer_Day_Mobile_767x845.7314dd80.jpg";